module.exports = __webpack_public_path__ + "static/media/close.2ca824d3.svg";